module.exports = __webpack_public_path__ + "img/puerto-de-barcelona.eedea0b1.jpg";